<template>
  <v-container>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-if="additionalMeals.length" class="mx-2" fab dark x-small color="primary" v-on="on">
          <v-icon class="me-1" dark>mdi-exclamation</v-icon>
        </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Additional Meals</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="light--text" text @click="show_dialog_box = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="mt-2">
            <v-row>
              <v-col>
                Category
              </v-col>
              <v-col>
                Count
              </v-col>
              <v-col>
                Price
              </v-col>
            </v-row>
            <v-row v-for="item in additionalMeals" :key="item._id">
              <v-col>
                <span v-if="item.category">
                  <strong> {{ item.category.nameEn }}</strong>
                </span>
              </v-col>
              <v-col>
                <strong> {{ item.mealCount }}</strong>
              </v-col>
              <v-col>
                <strong>{{ item.mealPrice.toFixed(3) }} KD</strong>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  components: {},
  props: {
    additionalMeals: {
      required: false,
    },
    subscription: {
      required: false,
    },
  },
  methods: {},
  data: () => ({
    loading: true,
    valid: false,
    show_dialog_box: false,
  }),

  created() {},
};
</script>
